// React imports.
import React from "react";

// App imports.
import { IndexHistory } from '../state'
import * as utility from "../utility";

interface BenefitTargeting2Props {
     history: IndexHistory;
}

function BenefitTargeting2({ history }: BenefitTargeting2Props) {
     // Helper method to safely access LatestYear properties with correct typing
     const getLatestYearValue = <T,>(key: string, fallback: T): T => {
          return history.LatestYear && history.LatestYear[key] !== undefined ? history.LatestYear[key] : fallback;
     };

     return (
          <div >
               <h2>{history.SelectedIndexString}   Index – Representativeness of Your FY{getLatestYearValue('Year', '')} Data</h2>
               <br />
               <p>The results for your {history.SelectedIndexString}   Index are based on data that were collected for a portion of your LIHEAP recipient households. </p>
               <p>In FY{getLatestYearValue('Year', '')}, {history.GranteeName}   provided bill payment assistance to   {getLatestYearValue('HouseholdsAssisted', 0).toLocaleString()}   households.&nbsp; Of those households, performance data were collected and reported for    {getLatestYearValue('HouseholdsCompleteData', 0).toLocaleString()}    or     {getLatestYearValue('IndexRepresentsPctString', '')}     of those households. </p>
               <p>This means that your <strong>{history.SelectedIndexString}    Index </strong>value is based on     {getLatestYearValue('IndexRepresentsPctString', '')}      of your bill payment assisted households.</p>
               <br />
               <table>
                    <thead>
                         <tr>
                              <th>Number of Bill Payment Assisted Households</th>
                              <th>Number of Bill Payment Assisted Households with Complete Performance Data</th>
                              <th>Percentage of Bill Payment Assisted Households Represented by Your Performance Data</th>
                         </tr>
                    </thead>
                    <tbody>
                         <tr>
                              <td>{getLatestYearValue('HouseholdsAssisted', 0).toLocaleString()}</td>
                              <td>{getLatestYearValue('HouseholdsCompleteData', 0).toLocaleString()}</td>
                              <td>{getLatestYearValue('IndexRepresentsPctString', '')}</td>
                         </tr>
                    </tbody>
               </table>
               <br /><br />
               <p> <span>Please click <em>Next </em>to continue.</span></p>

          </div>
     )
}

export default BenefitTargeting2;

